import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { clientAccountsPageValidateSearchSchema } from '../../products/ClientAccountsPage/route';
import { accountTerminationReason } from '../constants/accountTerminationReason';
import { accountTerminationRoute } from '../route';

const accountTerminationSettlementRouteSearchSchema =
	clientAccountsPageValidateSearchSchema.extend({
		reason: z.enum(accountTerminationReason),
		reasonNote: z.string().optional(),
		openedDocument: z.string().optional(),
		documentUuids: z.array(z.string()).optional().prefault([]),
		predefinedSettlementAccountIso: z.string().optional(),
		terminationDate: z.coerce.date().optional(),
	});

export const accountTerminationSettlementRoute = createRoute({
	getParentRoute: () => accountTerminationRoute,
	path: '/2-settlement',
	component: lazyRouteComponent(
		() => import('./AccountTerminationSettlementPage'),
		'AccountTerminationSettlementPage',
	),
	validateSearch: accountTerminationSettlementRouteSearchSchema,
});
